import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { SandboxProfile } from "./sandboxUser";

type Overrides = Partial<SandboxProfile>;

type State = {
  byId: Record<string, Overrides>;
  setOverride: (id: string, patch: Overrides) => void;
};

export const useSandboxProfileOverrides = create<State>()(
  persist(
    (set) => ({
      byId: {},
      setOverride: (id, patch) =>
        set((s) => ({ byId: { ...s.byId, [id]: { ...(s.byId[id] ?? {}), ...patch } } })),
    }),
    { name: "sc-sandbox-profile-overrides" },
  ),
);

export function applyOverrides(id: string, base: SandboxProfile): SandboxProfile {
  const patch = useSandboxProfileOverrides.getState().byId[id];
  return patch ? { ...base, ...patch } : base;
}